import React, { useEffect, useState } from "react";
import { NumberInput } from "../../../components/inputs/new-input";
import SyncIcon from "@mui/icons-material/Sync";
import { warningSnackBar, infoSnackBar } from "../../../actions/common.action";
import { useDispatch } from "react-redux";

export default function TaskTemplate({
  templateId = "",
  templateName = "",
  selectedQty = 1,
  col = 4,
  editMode = false,
  enableEditBtn = false,
  isTaskTemplateQty = false,
  isVariation = false,
  ...props
}) {
  const [fields, setFields] = useState({
    selectedQty: {
      name: "selectedQty",
      type: "number",
      // label: 'Qty',
      touched: false,
      error: false,
      valid: true,
      disabled: !editMode, // Always disabled initially
      value: selectedQty || 1, // Default to 1 if no selectedQty
      min: 0,
      "data-cy": "template-quantity-input",
    },
  });
  const dispatch = useDispatch();
  const [isRotated, setIsRotated] = useState(false);
  const [changedQty, setChangedQty] = useState(false);
  const [currentSelectedQty, setCurrentSelectedQty] = useState(
    selectedQty || 1
  );
  const containerDataCy = isTaskTemplateQty
    ? "task-container"
    : "subtask-container";

  useEffect(() => {
    setFields((prev) => ({
      ...prev,
      selectedQty: { ...prev.selectedQty, disabled: !editMode },
    }));
  }, [editMode]);

  useEffect(() => {
    setFields((prev) => ({
      ...prev,
      selectedQty: { ...prev.selectedQty, value: selectedQty || 1 },
    }));
    setCurrentSelectedQty(selectedQty || 1);
  }, [selectedQty]);

  const itemChangeHandler = (e) => {
    const value = Math.max(0, Number(e.target.value));
    setFields((prev) => ({
      ...prev,
      selectedQty: { ...prev.selectedQty, value: value },
    }));
    if (value !== currentSelectedQty) {
      setChangedQty(true);
    } else {
      setChangedQty(false);
    }
  };
  const refreshHandler = (e) => {
    const value = parseFloat(fields.selectedQty.value);
    if (parseFloat(currentSelectedQty) === value) {
      setChangedQty(false);
      return;
    }
    if (isNaN(value) || value <= 0) {
      if (dispatch) {
        dispatch(
          warningSnackBar(
            "Quantity must be greater than 0. Please enter a valid quantity before refreshing."
          )
        );
      }
      return;
    }
    setIsRotated(!isRotated);
    if (props.refreshHandler) {
      const subTask = props?.item || {};
      const items = [
        {
          ...subTask,
          selectedQty: fields.selectedQty.value,
          templateQuantity: fields.selectedQty.value,
        },
      ];
      props.refreshHandler(items);
    }
    setTimeout(() => {
      setIsRotated((prev) => !prev);
    }, 1000); //this duration is used on transition time in syncIcon

    setChangedQty(false);
    setCurrentSelectedQty(value);
    if (dispatch) {
      dispatch(
        infoSnackBar(
          "Template refreshed successfully. Please save to apply the changes. Note: manual changes will not be recalculated."
        )
      );
    }
  };

  return (
    <div data-cy={containerDataCy}>
      <div
        className={`text-left d-flex align-items-center gap-3 ${props?.className || ""}`}
      >
        <div
          className={`${props?.templateNameClass || ""}`}
          data-cy="template-name"
        >
          <label>Template:</label> {templateName || "No Template Selected"}
        </div>
        <div
          className={`d-flex border-start col-${col} ps-3 align-items-center`}
        >
          <span>Qty:</span>
          <NumberInput
            className="h-100 input-block-sm ps-2"
            {...fields.selectedQty}
            customInputClass="h-100 text-right"
            onChange={(e) => itemChangeHandler(e)}
            onBlur={(e) => itemChangeHandler(e)}
          />
        </div>
        {editMode && (
          <span
            title="Update Template Qty"
            className="border-start ps-3"
            disabled={!editMode}
          >
            <SyncIcon
              className={`fs-4 sync-icon 
                ${isRotated ? "rotate-90-degree" : ""} 
                ${changedQty ? "fill-red-breathe" : "fill-green"}`
              }
              onClick={(e) => refreshHandler(e)}
              data-cy="template-quantity-refresh-btn"
            />
          </span>
        )}
      </div>
      <div data-cy="template-quantity-info-container" disabled={!changedQty}>
        {!editMode && !changedQty && !isVariation && (
          <>
            <em className="text-nowrap brand-color-1 fst-12 fw-semibold">
              *Any changes to the template quantity can be completed within the
              Edit Task button.
            </em>
            <br />
            <em
              className="text-nowrap brand-color-1 fst-12 fw-semibold"
              data-cy="template-quantity-info-2"
            >
              *Quantity changes will only apply to items originally imported
              from the Task Template Items.
            </em>
          </>
        )}
        {changedQty && (
          <em
            className="text-nowrap brand-color-1 fst-12 fw-semibold mt-5"
            data-cy="template-quantity-changed-info"
          >
            *You have changed the template quantity. Please click the refresh
            button to apply changes to calculations.
          </em>
        )}
      </div>
    </div>
  );
}
